import React, { useState } from "react";
import { Button, Card, Form, Input, Typography, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { getErrorMessage, isSuccess, rfidAdminApi } from "../hooks/rfidAdminApi";
import "../pages/rfid/RfidAdmin.css";

const { Title, Paragraph } = Typography;
export const AUTH_STORAGE_KEY = "rfid_admin_auth";

export function readAdminAuth() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(AUTH_STORAGE_KEY) || "null");
    return parsed?.authenticated && parsed?.access_token ? parsed : null;
  } catch (_) {
    sessionStorage.removeItem(AUTH_STORAGE_KEY);
    return null;
  }
}
export function saveAdminAuth(data) {
  const auth = {
    authenticated: true,
    id: data?.id || "",
    user_name: data?.user_name || "",
    length: Number(data?.length || 0),
    goal_distance: Number(data?.goal_distance || 3000),
    access_token: data?.access_token || "",
    authenticatedAt: Date.now(),
  };
  sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
  return auth;
}
export const clearAdminAuth = () => sessionStorage.removeItem(AUTH_STORAGE_KEY);

const AuthGate = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [auth, setAuth] = useState(() => readAdminAuth());
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values) => {
    try {
      setLoading(true);
      const payload = { app_key: String(values.app_key || "") };
      if (values.user_name) payload.user_name = String(values.user_name).trim();
      const res = await rfidAdminApi.compareSchool(payload);
      if (!isSuccess(res)) throw new Error(res?.error || "비밀번호가 올바르지 않습니다.");
      setAuth(saveAdminAuth(res.data || {}));
      messageApi.success("인증되었습니다.");
    } catch (error) {
      messageApi.error(getErrorMessage(error, "비밀번호 확인에 실패했습니다."));
    } finally { setLoading(false); }
  };

  if (auth?.authenticated) {
    return children({ auth, logout: () => { clearAdminAuth(); setAuth(null); } });
  }

  return (
    <div className="rfid-auth-wrap">
      {contextHolder}
      <Card className="rfid-auth-card">
        <div className="rfid-auth-icon"><LockOutlined /></div>
        <Title level={3} style={{ textAlign: "center", marginBottom: 8 }}>School Run RFID Admin</Title>
        <Paragraph type="secondary" style={{ textAlign: "center" }}>RFID 리더, 태그, 학생 배정과 판독 기록을 관리합니다.</Paragraph>
        <Form form={form} layout="vertical" onFinish={handleLogin}>
          <Form.Item name="user_name" label="사용자명"><Input placeholder="선택 입력" autoComplete="username" /></Form.Item>
          <Form.Item name="app_key" label="비밀번호" rules={[{ required: true, message: "비밀번호를 입력해주세요." }]}>
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>로그인</Button>
        </Form>
      </Card>
    </div>
  );
};
export default AuthGate;
